export default "__VITE_ASSET__CQGScyT$__"